<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



$(document).ready(function() {
  $('.sr-mega-menu a').mouseover(function() {
    // Store the original text
    $(this).data('originalText', $(this).find('.text').text());
    // Change the text
    $(this).find('.text').text('Visit this collection ->');
  }).mouseout(function() {
    // Retrieve and restore the original text
    $(this).find('.text').text($(this).data('originalText'));
  });
   var sidebarWrapper = $('.halo-sidebar-wrapper');
    var socialLists = $('.list-social');
    
    socialLists.one('appendSocialList', function() {
        if (sidebarWrapper.length > 0 && $(this).length > 0) {
            sidebarWrapper.append($(this).clone());
        }
    });

    socialLists.eq(0).trigger('appendSocialList');
});
